import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'app-l-list',
  imports: [],
  templateUrl: './l-list.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './l-list.component.css'
})
export class LListComponent {

}
